/* eslint-disable max-len */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import {useContext ,useState} from "react"
import GlobalContext from '../../../components/Context/GloablContext'
import Pagination from '../../../components/Pagination'
import Limit from '../../../components/Limit'
import CustomOverLay from '../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import BloodGlouseVitalTable from './Table'
import Emptyscreenwithouttitle from '../../../components/Emptyscreenwithouttitle'
import { Link, useSearchParams } from 'react-router-dom'
import { useVitalReadingListQuery } from '../../../features/patientSlice'
import { useDispatch } from 'react-redux'
import { useAcknowledgeAlertMutation } from '../../../features/alertSlice'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import Loader from '../../../components/Loader'
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import HelpGuideModal from '../../../components/HelpGuideModal'
import { handleSidebarPrvState } from '../../../redux/systemConfigSlice'


export default function DeviceAlertList({wellnessDetails,wellnessFetching,setIsStateLoading}) {
    const [acknowledge] = useAcknowledgeAlertMutation()
    const [searchParams,setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(false)
    // Remove 'tabname' from searchParams and append the required keys for the API call
    const getFilteredSearchParams = () => {
        const filteredParams = new URLSearchParams(searchParams);
        filteredParams.delete("tabname"); // Remove 'tabname'
        return filteredParams.toString(); // Return the updated searchParams as a string
    };

    const {data,isFetching,status,refetch}=useVitalReadingListQuery( getFilteredSearchParams(),{skip:searchParams.size<4,refetchOnMountOrArgChange:true})
    const dispatch = useDispatch()
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
  
    const [acknowledgeModal, setAcknowledgeModal] = useState(false)
    const [selectedAlert, setSelectedAlert] = useState({})
    const {isSideBar,setToastmessage,setToastErrorMessage,setIsAdvancedSearchOpen,setIsSideBar} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-dashboard-device-alerts');
        } else {
            setQueryParamsadmin('type=corporate-dashboard-device-alerts');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    useEffect(() => {
        let defaultParams = {
            limit: "15",
            page_number: "1",
            reading_type: "all",
            filter: "true",
            type: "alerts",
            tabname: "device_alerts",
            patient_id: location.pathname.split("/")?.[3],
        };

        // Convert searchParams to an object
        let currentParams = Object.fromEntries(searchParams.entries());

        // Merge default params with existing params (retaining user-added params)
        let mergedParams = { ...defaultParams, ...currentParams };

        setSearchParams(mergedParams);
    }, [location, searchParams]);   

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setAcknowledgeModal(false)
    }

    const handleAcknowlegde = (item) => {
        setSelectedAlert(item)
        setAcknowledgeModal(true)
    }

    const handleFinalAcknowledge = async () => {
        setLoading(true)
        const response = await acknowledge(selectedAlert._id)
        if(response?.data){
            setToastmessage(`Alert acknowledged successfully`);
            setAcknowledgeModal(false)
            refetch()
            setLoading(false)
        } else {
            setToastErrorMessage('Something went wrong. Please try again')
            setAcknowledgeModal(false)
            setLoading(false)
        }
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        dispatch(handleSidebarPrvState(isSideBar));
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
    useEffect(() => {
        if (status !== 'fulfilled') {
            setIsStateLoading(true)
        } else {
            setIsStateLoading(false)
        }
    }, [status]);
 
    return (
        <div className={`bg-white rounded-lg py-3 h-[calc(100vh-391px)] ${((wellnessFetching||(isFetching&&status!=="fulfilled"&&status!=="rejected"))||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?'mt-4':''} relative`}>
            <div className='flex justify-between items-center mb-3'>
                {!wellnessFetching&&wellnessDetails?.patientData?.vital_reading_count!=='-'&&(
                    <>
                        <div>
                            <p className='text-[14px] leading-[20px] text-[#031624] font-normal mb-[16px]'>{`Current Readings Days = ${wellnessDetails?.patientData?.vital_reading_count}, ${wellnessDetails?.patientData?.vital_pending_days} Days left in cycle (Minimum ${wellnessDetails?.patientData?.vital_number_of_time_periods} in ${wellnessDetails?.patientData?.vital_time_period} )`}

                            </p>
                        </div>
                    </>)} 
                <div className='flex items-center'>
                    <button 
                        id='search-btn'
                        type='button'
                        onClick={() => handleSearchClick()}
                        className="ml-2.5 mr-3 border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" />
                    </button>
                    {
                        userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                    }
                </div>
            </div>
            
            {((wellnessFetching||(isFetching&&status!=="fulfilled"&&status!=="rejected"))||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text={`Loading Device Alerts...`} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'linked_providers_overlay' : 'opened_linked_providers_overlay'}`}/>: (data!==undefined && data?.historical_reading?.length > 0 ) ? <> 
                <div className="">
                    <BloodGlouseVitalTable
                        pageNumber={Number(searchParams.get('page_number')) || 1}
                        List={data}
                        handleSearchParams={handleSearchParams}
                        handleAcknowlegde={handleAcknowlegde}
                    />
                </div>
                {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                    <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                    <div className="flex items-center">
                        <Limit
                            limit={limit}
                            setLimit={setLimit}
                            handleNoOfRowsClick={handleNoOfRowsClick}
                        />
                        <Pagination
                            TotalCount={parseInt(data?.total_count)}
                            totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                            // limit={Number(searchParams.get('limit'))}
                            limit={parseInt(limit)}
                        />
                    </div>
                </div>}
            </>:<>
                {(data?.total_count===0)||(data?.success_status==="false")  ?
                    <SearchEmptyScreen text={"No exact matches found. Please try a different search"}  DeviceAlertList={true}/>
                    : data?.historical_reading?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                        <SearchEmptyScreen 
                            isPatient={true}
                            text={"That filter combination has no result. Please try different criteria"} 
                        />
                        :
                        data?.total_count===0?<Emptyscreenwithouttitle
                            title={"Device Alerts"}
                            FirstPTag={'No Device Alerts yet'}
                            customHeight={true}
                        />:((status==="rejected"||(data?.total_count!==0&&data?.historical_reading?.length===0))&&<SearchEmptyScreen text={"No data found"} />
                        )
                }
            </>}
            {acknowledgeModal &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        // emptyField={emptyArea}
                        // setEmptyField={setEmptyArea}
                        // setTextAreaMsg={setTextAreaMsg}
                        // textAreaMsg={""}
                        handleOnCLickActivate={handleFinalAcknowledge}
                        handleClose={handleConformationClick}
                        tittle={`Acknowledge`}
                        message={`Are you sure you want to acknowledge this?`}
                        textMessage={true === false ? false : true}
                        buttonName={true && !loading ? "Acknowledge" : <span>{<Loader />}</span>}
                        // CancelButton={'No'}
                        disabled={loading}
                    />
                }
            />
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </div>
    )
}
